import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCoins = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3924_17256)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M5.33398 9.33325C7.54312 9.33325 9.33398 7.54239 9.33398 5.33325C9.33398 3.12411 7.54312 1.33325 5.33398 1.33325C3.12485 1.33325 1.33398 3.12411 1.33398 5.33325C1.33398 7.54239 3.12485 9.33325 5.33398 9.33325Z",
				strokeWidth: 1,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.0592 6.91333C12.6895 7.14828 13.2502 7.53835 13.6897 8.04746C14.1293 8.55657 14.4333 9.16829 14.5737 9.82604C14.7142 10.4838 14.6865 11.1663 14.4933 11.8106C14.3 12.4548 13.9475 13.0399 13.4682 13.5117C12.9889 13.9836 12.3984 14.327 11.7512 14.5101C11.1041 14.6933 10.4212 14.7103 9.7657 14.5596C9.11022 14.4089 8.50332 14.0954 8.00113 13.648C7.49894 13.2006 7.11767 12.6338 6.89258 12",
				strokeWidth: 1,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M4.66602 4H5.33268V6.66667",
				strokeWidth: 1,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11.1399 9.25342L11.6066 9.72675L9.72656 11.6068",
				strokeWidth: 1,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3924_17256",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 16,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgCoins;
